import Layer2ChainWeb3Strategy from './layer2-chain';
export default class SokolWeb3Strategy extends Layer2ChainWeb3Strategy {
  constructor() {
    super('sokol');
  }
}
